<template>
  <div class="question-wrap" ref="questionWrapRef">
    <div class="question-wrap-left" v-if="qaType == '1'">
      <el-scrollbar always>
        <el-menu :default-active="taxActive" @select="menuSelect">
          <el-tooltip :content="title" placement="right">
            <el-text truncated>{{ title }}</el-text>
          </el-tooltip>

          <el-menu-item-group>
            <el-menu-item v-for="(item, index) of taxList" :key="index" :index="item.type">
              <el-text truncated>
                {{ item.title }}
                <el-button v-if="mode == 5" size="small" type="primary" class="desc-btn" @click="descShow(item)">表格描述</el-button>
              </el-text>
            </el-menu-item>
          </el-menu-item-group>
        </el-menu>
      </el-scrollbar>
    </div>

    <div class="question-wrap-right">
      <div v-if="qaType != '1'" style="display: flex; flex-direction: row-reverse; padding: 5px 10px 5px 0">
        <el-button plain style="margin-left: 15px" @click="emit('save')" type="primary">暂存</el-button>
        <el-button plain type="primary">上传附送资料</el-button>
      </div>
      <el-scrollbar class="el-scrollbar-question-wrap-right" always>
        <component :is="view" ref="viewRef" />
      </el-scrollbar>
    </div>

    <descDialog ref="descDialogRef" @submit="descDialogSubmit" />
  </div>
</template>

<script setup>
// 4.财务报表报送（季度）
import Big from "big.js";
import { nextTick, toRaw } from "vue";
import { ElMessage } from "element-plus";
import { cloneDeep } from "lodash";
import descDialog from "../cmp/descDialog.vue";
import tax51 from "./cmp/tax51.vue";
import tax52 from "./cmp/tax52.vue";
import tax53 from "./cmp/tax53.vue";
import tax54 from "./cmp/tax54.vue";
import tax55 from "./cmp/tax55.vue";
import tax56 from "./cmp/tax56.vue";
import tax57 from "./cmp/tax57.vue";
import tax58 from "./cmp/tax58.vue";
import tax59 from "./cmp/tax59.vue";
import tax510 from "./cmp/tax510.vue";
import { $emit } from "vue-happy-bus";

const props = defineProps({
  qaType: {
    // 页面类型，默认为1即原始的设置题目，通过菜单切题页面。 其他情况为组件名称即： tax21,tax22
    type: String,
    default: "1",
  },
});

watch(
  () => props.qaType,
  (newVal) => {
    if (newVal == "1") {
      return;
    }
    //nextTick(() => {
    menuSelect(newVal);
    //});
  },
  { immediate: true }
);

const emit = defineEmits(["save", "taxSave"]);

const viewRef = ref();
const isDev = ref(import.meta.env.DEV);
const isSet = ref(location.search.includes("isSet=111"));
const title = ref("汇算清缴-企业所得税年度申报");
const taxList = ref([
  {
    title: "《封面》",
    type: "tax51",
  },
  {
    title: "《A000000企业基础信息表》",
    type: "tax52",
  },
  {
    title: "《A100000企业所得税年度纳税申报主表》",
    type: "tax53",
  },
  {
    title: "《A105000纳税调整项目明细表》",
    type: "tax54",
  },
  {
    title: "《A105050职工薪酬支出及纳税调整明细表》",
    type: "tax55",
  },
  {
    title: "《A105060广告费和业务宣传费等跨年度纳税调整明细表》",
    type: "tax56",
  },
  {
    title: "《A105070捐赠支出及纳税调整明细表》",
    type: "tax57",
  },
  {
    title: "《A105080资产折旧、摊销情况及纳税调整明细表》",
    type: "tax58",
  },
  {
    title: "《A105090资产损失税前扣除及纳税调整明细表》",
    type: "tax59",
  },
  {
    title: "《A106000企业所得税弥补亏损明细表》",
    type: "tax510",
  },
]);
const taxActive = ref("tax51");
const view = shallowRef(null);
const views = {
  tax51,
  tax52,
  tax53,
  tax54,
  tax55,
  tax56,
  tax57,
  tax58,
  tax59,
  tax510,
};
view.value = views[taxActive.value];

const descDialogRef = ref(null);
const descShow = (data) => {
  const { desc } = taxDataAll.value[data.type];
  descDialogRef.value.open(Object.assign({}, data, { desc }));
};
const descDialogSubmit = ({ type, desc }) => {
  Object.assign(taxDataAll.value[type], {
    desc,
  });

  emit("taxSave");
};

const mode = ref(null);
const taxDataAll = ref({
  tax51: {
    status: 0, // 0 未填写 1 已填写
    desc: "", // 描述
    // 表单数据
    data: {
      // 文本数据
      v1x1: {
        value: "",
      },
      v1x2: {
        value: "",
      },
    },
  },
  tax52: {
    status: 0, // 0 未填写 1 已填写
    desc: "", // 描述
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(25, 6),
      // 文本数据
      v1x1: {
        value: "",
      },
      v3x1: {
        value: "",
      },
      // 单选数据
      v3x2: {
        value: "",
      },
      v4x2: {
        value: "",
      },
      v5x1: {
        value: "",
      },
      v7x2: {
        value: "",
      },
      v22x1: {
        value: "",
      },
      // 复选数据
      v5x2: {
        value: [],
      },
      v6x1: {
        value: false,
      },
      v6x2: {
        value: false,
      },
      v8x2: {
        value: [],
      },
      v9x1: {
        value: false,
      },
      v9x2: {
        value: false,
      },
      v10x2: {
        value: false,
      },
      v11x2: {
        value: [],
      },
      v16x1: {
        value: [],
      },
      v18x1: {
        value: false,
      },
      v18x2: {
        value: false,
      },
      v19x1: {
        value: false,
      },
      v19x2: {
        value: false,
      },
      v20x1: {
        value: false,
      },
      v20x2: {
        value: false,
      },
      v21x1: {
        value: false,
      },
      v21x2: {
        value: false,
      },
      // 选择框数据
      v4x1: {
        value: "",
      },
      v23x2: {
        value: "",
      },
      v23x6: {
        value: "",
      },
      v24x2: {
        value: "",
      },
      v24x6: {
        value: "",
      },
      // 文本数据
      v12x1: {
        value: "",
      },
      v12x2: {
        value: "",
      },
      v13x1: {
        value: "",
      },
      v13x2: {
        value: "",
      },
      v14x1: {
        value: "",
      },
      v14x2: {
        value: "",
      },
      v15x1: {
        value: "",
      },
      v15x2: {
        value: "",
      },
      v16x2: {
        value: "",
      },
      v17x1: {
        value: "",
      },
      v17x2: {
        value: "",
      },
      v23x1: {
        value: "",
      },
      v23x3: {
        value: "",
      },
      v24x1: {
        value: "",
      },
      v24x3: {
        value: "",
      },
      // 考题设置数据 - 数字数据
      v2x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v23x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v24x4: {
        value: 0,
        answer: null,
        score: null,
      },
      // 考题设置数据 - 单选数据
      v3x2: {
        value: "",
        answer: null,
        score: null,
      },
      v4x2: {
        value: "",
        answer: null,
        score: null,
      },
      v5x1: {
        value: "",
        answer: null,
        score: null,
      },
      v7x2: {
        value: "",
        answer: null,
        score: null,
      },
      v22x1: {
        value: "",
        answer: null,
        score: null,
      },
      // 考题设置数据 - 选择框数据
      v4x1: {
        value: "",
        answer: null,
        score: null,
      },
      v23x2: {
        value: "",
        answer: null,
        score: null,
      },
      v24x2: {
        value: "",
        answer: null,
        score: null,
      },
      v23x6: {
        value: "",
        answer: null,
        score: null,
      },
      v24x6: {
        value: "",
        answer: null,
        score: null,
      },
      // 考题设置数据 - 文本数据
      v23x1: {
        value: "",
        answer: null,
        score: null,
      },
      v24x1: {
        value: "",
        answer: null,
        score: null,
      },
      v23x3: {
        value: "",
        answer: null,
        score: null,
      },
      v24x3: {
        value: "",
        answer: null,
        score: null,
      },
    },
  },
  tax53: {
    status: 0, // 0 未填写 1 已填写
    desc: "", // 描述
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(49, 1),
      v22_1x1: {
        value: 0,
      },
      v22_2x1: {
        value: 0,
      },
      v29x1: {
        value: 0.25,
      },
      v31_1x1: {
        value: 0,
      },
      v31_2x1: {
        value: 0,
      },
      // 考题设置数据 - 数字数据
      v1x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v3x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v4x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v5x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v7x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v15x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v16x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v17x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v18x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v20x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v22x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v22_1x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v22_2x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v24x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v26x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v28x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v30x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v31x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v31_1x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v31_2x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v33x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v36x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v37x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v38x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v45x1: {
        value: 0,
        answer: null,
        score: null,
      },
    },
  },
  tax54: {
    status: 0, // 0 未填写 1 已填写
    desc: "", // 描述
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(50, 4),
      v39_1x1: {
        value: 0,
      },
      v39_1x2: {
        value: 0,
      },
      v39_1x3: {
        value: 0,
      },
      v39_1x4: {
        value: 0,
      },
      v39_2x1: {
        value: 0,
      },
      v39_2x2: {
        value: 0,
      },
      v39_2x3: {
        value: 0,
      },
      v39_2x4: {
        value: 0,
      },
      v39_3x1: {
        value: 0,
      },
      v39_3x2: {
        value: 0,
      },
      v39_3x3: {
        value: 0,
      },
      v39_3x4: {
        value: 0,
      },
      v39_4x1: {
        value: 0,
      },
      v39_4x2: {
        value: 0,
      },
      v39_4x3: {
        value: 0,
      },
      v39_4x4: {
        value: 0,
      },
      v39_5x1: {
        value: 0,
      },
      v39_5x2: {
        value: 0,
      },
      v39_5x3: {
        value: 0,
      },
      v39_5x4: {
        value: 0,
      },
      v39_6x1: {
        value: 0,
      },
      v39_6x2: {
        value: 0,
      },
      v39_6x3: {
        value: 0,
      },
      v39_6x4: {
        value: 0,
      },
      v39_7x3: {
        value: 0,
      },
      v39_7x4: {
        value: 0,
      },
      // 考题设置数据 - 数字数据
      v12x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v14x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v14x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v14x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v14x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v15x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v15x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v15x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v17x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v17x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v19x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v19x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v32x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v32x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v34x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v34x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v46x3: {
        value: 0,
        answer: null,
        score: null,
      },
    },
  },
  tax55: {
    status: 0, // 0 未填写 1 已填写
    desc: "", // 描述
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(13, 7),
      v3x3: {
        value: 0.14,
      },
      v5x3: {
        value: 0.08,
      },
      v6x3: {
        value: 1,
      },
      v7x3: {
        value: 0.02,
      },
      v10x3: {
        value: 0.05,
      },
      v11x3: {
        value: 0.05,
      },
      v12x3: {
        value: 0,
      },
      // 考题设置数据 - 数字数据
      v1x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v3x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v3x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v3x5: {
        value: 0,
        answer: null,
        score: null,
      },
      // v4x1: {
      //   value: 0,
      //   answer: null,
      //   score: null,
      // },
      // v4x2: {
      //   value: 0,
      //   answer: null,
      //   score: null,
      // },
      // v4x5: {
      //   value: 0,
      //   answer: null,
      //   score: null,
      // },
      // v4x6: {
      //   value: 0,
      //   answer: null,
      //   score: null,
      // },
      // v4x7: {
      //   value: 0,
      //   answer: null,
      //   score: null,
      // },
      v5x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v5x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v5x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v7x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v7x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v7x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v7x6: {
        value: 0,
        answer: null,
        score: null,
      },
      v8x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v8x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v8x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v13x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v13x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v13x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v13x6: {
        value: 0,
        answer: null,
        score: null,
      },
      v13x7: {
        value: 0,
        answer: null,
        score: null,
      },
    },
  },
  tax56: {
    status: 0, // 0 未填写 1 已填写
    desc: "", // 描述
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(13, 2),
      v5x1: {
        value: 0.15,
      },
      v5x2: {
        value: 0.18,
      },
      // 考题设置数据 - 数字数据
      v1x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v3x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v4x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x1: {
        value: 0,
        answer: null,
        score: null,
      },
    },
  },
  tax57: {
    status: 0, // 0 未填写 1 已填写
    desc: "", // 描述
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(12, 7),
      // 多行数据
      v8x1: {
        value: [
          {
            type: "",
            value: 0,
          },
        ],
      },
      // 考题设置数据 - 数字数据
      v2x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v11x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v11x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v11x4: {
        value: 0,
        answer: null,
        score: null,
      },
    },
  },
  tax58: {
    status: 0, // 0 未填写 1 已填写
    desc: "", // 描述
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(31, 9),
      // 考题设置数据 - 数字数据
      v1x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x8: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x8: {
        value: 0,
        answer: null,
        score: null,
      },
      v3x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v3x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v3x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v3x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v3x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v3x8: {
        value: 0,
        answer: null,
        score: null,
      },
      v5x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v5x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v5x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v5x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v5x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v5x8: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x8: {
        value: 0,
        answer: null,
        score: null,
      },
      v18x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v18x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v18x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v18x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v18x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v18x8: {
        value: 0,
        answer: null,
        score: null,
      },
      v30x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v30x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v30x3: {
        value: 0,
        answer: null,
        score: null,
      },
      v30x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v30x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v30x8: {
        value: 0,
        answer: null,
        score: null,
      },
    },
  },
  tax59: {
    status: 0, // 0 未填写 1 已填写
    desc: "", // 描述
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(30, 7),
      // 考题设置数据 - 数字数据
      v5x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v5x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v5x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v5x6: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x6: {
        value: 0,
        answer: null,
        score: null,
      },
      v29x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v29x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v29x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v29x6: {
        value: 0,
        answer: null,
        score: null,
      },
    },
  },
  tax510: {
    status: 0, // 0 未填写 1 已填写
    desc: "", // 描述
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(12, 12),
      // 考题设置数据 - 数字数据
      v8x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v9x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v10x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v11x2: {
        value: 0,
        answer: null,
        score: null,
      },
      v10x8: {
        value: 0,
        answer: null,
        score: null,
      },
      v10x9: {
        value: 0,
        answer: null,
        score: null,
      },
      v10x10: {
        value: 0,
        answer: null,
        score: null,
      },
      v11x10: {
        value: 0,
        answer: null,
        score: null,
      },
    },
  },
});
// 初始化
const taxInit = (options = {}) => {
  nextTick(() => {
    try {
      // 合并数据
      mode.value = options.mode;
      if (options.taxDataAll) {
        taxDataAll.value = options.taxDataAll;
      }

      // 当前税表数据
      const taxData = taxDataAll.value[taxActive.value];
      console.log("初始化数据", {
        mode: mode.value,
        taxDataAll: toRaw(taxDataAll.value),
        taxData: toRaw(taxData),
      });
      // 初始化
      viewRef.value.init({
        mode: mode.value,
        taxDataAll: toRaw(taxDataAll.value),
        taxData: toRaw(taxData),
      });
    } catch (e) {
      console.log(e);
    }
  });
};

const currentQa = inject("provideCurrentQa");
emitQaDescChange("tax51");

// 通知外层组件更换试题描述
function emitQaDescChange(currentTableKey) {
  if (currentQa?.value?.answer || currentQa?.value?.standardAnswer) {
    $emit("setAnsQuestionBoard", JSON.parse(currentQa.value.answer || currentQa.value.standardAnswer)[currentTableKey]?.desc);
  }
}

// 切换税表
const menuSelect = (value) => {
  emitQaDescChange(value);
  // 暂存
  if (mode.value == 1) {
    taxSave(1);
  } else {
    taxSave(2);
    emit("taxSave", { showLoading: false });
  }
  taxActive.value = value;
  view.value = views[value];
};
// 合并选项 合并选项操作只做一次
const taxInitOptionsExtendDone = ref(false);
const taxInitOptionsExtend = (options) => {
  if (!taxInitOptionsExtendDone.value) {
    mode.value = options.mode;
    if (options.taxDataAll) {
      taxDataAll.value = options.taxDataAll;
    }

    taxInitOptionsExtendDone.value = true;
  }
};
// 保存
const taxSave = (type = 1) => {
  // type
  // 1 暂存 不更新填写状态 不根据联表映射规则更新其他tax数据 不发送给后端
  // 2 保存 更新填写状态 根据联表映射规则更新其他tax数据 发送给后端
  console.log(`${["临时", "正式"][type - 1]}保存`);
  try {
    const getData = viewRef.value.getData;

    if (typeof getData === "function" && getData()) {
      // 1
      console.log("当前保存表格为", taxActive.value);
      // 2
      const _data = cloneDeep(getData());
      console.log("当前保存表格数据为", _data);
      // 3
      const _taxDataAll = cloneDeep(toRaw(taxDataAll.value));
      console.log("当前所有表格数据为", _taxDataAll);
      // 4
      _taxDataAll[taxActive.value].data = _data;
      console.log("更新当前保存表格数据到所有表格数据", _taxDataAll);

      if (type == 2) {
        // 5
        if (mode.value == 1) {
          _taxDataAll[taxActive.value].status = 1;
        }
        console.log("做题模式下，更新填写状态", _taxDataAll);
        // 6
        if ([1, 2, 5].includes(+mode.value)) {
          // ElMessage.warning("todo 做题模式下，根据联表映射规则更新其他tax数据");
          taxDataAllUpdate(taxActive.value, _taxDataAll);
        }
      }

      // 重新初始化
      taxInit({
        mode: mode.value, // 1 做题 2 设置题目 3 查看结果 4 查看答案
        taxDataAll: _taxDataAll, // 只有新建题目不需要传入taxDataAll 修改题目，做题，查看结果都需要传入
      });

      console.log("最终返回数据", _taxDataAll);
      return _taxDataAll;
    }
  } catch (e) {
    console.log(e);
  }
};

const questionWrapRef = ref();
const setHeight = () => {
  const $el = questionWrapRef.value;
  $el.style.height = `calc(100vh - ${$el.getBoundingClientRect().top}px - 10px)`;
};

onMounted(() => {
  setHeight();
});

// 联表做题逻辑
function taxDataAllUpdate(taxActive, taxDataAll) {
  console.log("做题模式下，根据联表映射规则更新其他tax数据", taxActive, taxDataAll);

  const tax53 = () => {
    // tax53保存时 将tax53第24行金额数值 带入tax510 第11行当年境内所得额列
    taxDataAll.tax510.data.v11x2.value = taxDataAll.tax53.data.v24x1.value;
    // tax53保存时 将tax53第18行金额数值乘12% 带入tax57 第6行3列 若小于0 取0
    taxDataAll.tax57.data.v6x3.value = Math.max(new Big(taxDataAll.tax53.data.v18x1.value).times(0.12).round(2).toNumber(), 0);
    // tax53保存时 保存第一行第一列数据到tax54表
    taxDataAll.tax54.data.v50x1.value = taxDataAll.tax53.data.v1x1.value;
  };

  const tax54 = () => {
    // tax54保存时 将tax54第46行调增金额列数值 带入tax53 第20行金额列
    taxDataAll.tax53.data.v20x1.value = taxDataAll.tax54.data.v46x3.value;
  };

  const tax510 = () => {
    // tax510保存时 将tax510第11行使用境内所得弥补列数值 带入tax53 第26行金额列
    taxDataAll.tax53.data.v26x1.value = taxDataAll.tax510.data.v11x10.value;
  };

  const tax55 = () => {
    // tax55保存时 将tax55第13行账载金额带入tax54第14行账载金额列
    taxDataAll.tax54.data.v14x1.value = taxDataAll.tax55.data.v13x1.value;
    // tax55保存时 将tax55第13行税收金额带入tax54第14行税收金额列
    taxDataAll.tax54.data.v14x2.value = taxDataAll.tax55.data.v13x5.value;
  };

  const tax57 = () => {
    // tax57保存时 第11行1,4,5,6带入 tax54第17行1,2,3,4列
    taxDataAll.tax54.data.v17x1.value = taxDataAll.tax57.data.v11x1.value;
    taxDataAll.tax54.data.v17x2.value = taxDataAll.tax57.data.v11x4.value;
    taxDataAll.tax54.data.v17x3.value = taxDataAll.tax57.data.v11x5.value;
    taxDataAll.tax54.data.v17x4.value = taxDataAll.tax57.data.v11x6.value;
  };

  const tax58 = () => {
    // tax58保存时 将tax58第30行累计折旧带入tax54第32行账载金额列
    taxDataAll.tax54.data.v32x1.value = taxDataAll.tax58.data.v30x2.value;
    // tax58保存时 将tax58第30行税收折旧带入tax54第32行税收金额列
    taxDataAll.tax54.data.v32x2.value = taxDataAll.tax58.data.v30x5.value;
  };

  const tax59 = () => {
    // tax59保存时 将tax59第29行资产损失直接计入本年带入tax54第34行账载金额列
    taxDataAll.tax54.data.v34x1.value = taxDataAll.tax59.data.v29x1.value;
    // tax59保存时 将tax59第29行资产损失的税收金额带入tax54第34行税收金额列
    taxDataAll.tax54.data.v34x2.value = taxDataAll.tax59.data.v29x6.value;
  };

  const taxDataAllUpdateFn = {
    tax53,
    tax54,
    tax510,
    tax55,
    tax57,
    tax58,
    tax59,
  }[taxActive];

  typeof taxDataAllUpdateFn === "function" && taxDataAllUpdateFn();
}

// 构造数字输入框数据
function createData(x = 10, y = 10) {
  const data = {};
  for (let i = 1; i <= x; i++) {
    for (let j = 1; j <= y; j++) {
      data[`v${i}x${j}`] = {
        value: isSet.value ? +`${i}${j}` : 0,
      };
    }
  }

  return data;
}

defineExpose({
  taxInit,
  taxSave,
});
</script>

<style lang="scss" scoped></style>
